<template>
  <div :class="{'drainage-load__content' : drainageLoad}" class="drainage-content">
    <LoadingSVG v-if="drainageLoad" class="drainage-loader"/>
    <form
      class="single"
      @submit.prevent="save()"
      v-else
    >
      <div class="drainage-header">

      <div class="buttons">
        <app-btn
          type="submit"
          :disabled="!data.name || !data.stageId || !data.drainageVolume || !data.dripVolume || data.drainagePercentage > 100"
        >
          {{$ml.get('Save')}}
        </app-btn>

        <app-btn
          @click.prevent="deleteDrainage()"
          v-if="drainages.find(e => {return e.drainageId == id})"
        >
          {{$ml.get('delete')}}
        </app-btn>
      </div>
      </div>

      <container>
        <template v-slot:header>
          {{ $ml.get(`IRRIGATION SPECIFICATIONS`) }}
        </template>
        <general />
      </container>

      <container v-if="data.name || drainages.find(e => {return e.drainageId == id})">
        <template v-slot:header>
          {{ $ml.get(`CROP INFO`) }}
        </template>
        <crop-info />
      </container>
      <container v-if="(data.name || drainages.find(e => {return e.drainageId == id})) && (data.cropId && data.varietyId && data.growingMethodId && data.stageId)">
        <template v-slot:header>
          {{ $ml.get(`ELEMENT LIST`) }}
        </template>
        <elements ref="elements" />
      </container>

    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import General from '@/components/drainage/General'
import CropInfo from '@/components/drainage/CropInfo'
import Elements from '@/components/drainage/Elements'
import Container from "@/components/common/HeadedContainer"
import LoadingSVG from '@/components/ui/LoadingSVG'

export default {
  data() {
    return {
      id: null
      }
  },
  computed: {
    ...mapGetters({
      data: 'drainage/data',
      template: 'drainage/template',
      drainages: 'drainage/drainages',
      drainageLoad: 'drainage/drainageLoad'
    })
  },
  methods: {
    sync() {
      if( this.id && this.id != 'new' ) {
        //load here if have id number
        this.$store.dispatch('drainage/selectSingleDrainage', this.id).then(res => 
          {
          }
        ).finally(() => {
          this.$store.commit('drainage/setDrainageLoading', false)
          });
      } else {
        this.$store.commit('drainage/setDrainageLoading', false)
      }
    },
    save() {
      let filteredNutrients = [];

      if(this.data.sampling_date) {
        if(this.drainages.find(e => e.drainageId == this.id)) {

        delete this.data.request
        delete this.data.result
        delete this.data.created_at
        delete this.data.updated_at
        delete this.data.userId

        this.data.data.forEach(e => {
          filteredNutrients.push({Element: e.Element, IrrigationWater: e.IrrigationWater, DrainageAnalysis: e.DrainageAnalysis, TargetValues: e.TargetValues})
        })

        const data = {
          dripDataPh: this.data.dripDataPh,
          dripDataEc: this.data.dripDataEc,
          drainageDataPh: this.data.drainageDataPh,
          drainageDataEc: this.data.drainageDataEc,
          drainagePercentage: this.data.drainagePercentage,
          drainageVolume: this.$store.getters['unit/unConvert']('mL', this.data.drainageVolume),
          dripVolume: this.$store.getters['unit/unConvert']('mL', this.data.dripVolume),
          cropId: this.data.cropId,
          varietyId: this.data.varietyId,
          growingMethodId: this.data.growingMethodId,
          yieldGoalId: this.data.yieldGoalId,
          stageId: this.data.stageId,
          programId: this.data.programId,
          name: this.data.name,
          data: filteredNutrients,
          drainageId: this.data.drainageId,
          sampling_date: this.data.sampling_date
        }
        
        this.$store.dispatch('drainage/updateDrainage', data).then(res => {

          for(alert in res.result.PhAlerts) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(res.result.PhAlerts[alert].Message),
              type : 'err',
            })
          }

          for(alert in res.result.EcAlerts) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(res.result.EcAlerts[alert].Message),
              type : 'err',
            })
          }

          this.$notify({
              group: 'notices',
              title: this.$ml.get(`Drainage successfully saved!`),
              type : 'success',
          })
          let id = res.id;
          this.$store.dispatch('drainage/getUserDrainages').then(resp => {
            this.$store.dispatch('drainage/selectSingleDrainage', id).then(response => {
              this.$refs.elements.setNutrients(response.data);
            })
          })
          
          
          
        }, rej => {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Error`),
              type : 'err',
            })
        })
        
      } else {
        this.data.data.forEach(e => {
          filteredNutrients.push({Element: e.Element, IrrigationWater: e.IrrigationWater, DrainageAnalysis: e.DrainageAnalysis, TargetValues: e.TargetValues})
        })

        const data = {
          dripDataPh: this.data.dripDataPh,
          dripDataEc: this.data.dripDataEc,
          drainageDataPh: this.data.drainageDataPh,
          drainageDataEc: this.data.drainageDataEc,
          drainagePercentage: this.data.drainagePercentage,
          drainageVolume: this.$store.getters['unit/unConvert']('mL', this.data.drainageVolume),
          dripVolume: this.$store.getters['unit/unConvert']('mL', this.data.dripVolume),
          cropId: this.data.cropId,
          varietyId: this.data.varietyId,
          growingMethodId: this.data.growingMethodId,
          yieldGoalId: this.data.yieldGoalId,
          stageId: this.data.stageId,
          programId: this.data.programId,
          name: this.data.name,
          data: filteredNutrients,
          drainageId: this.data.drainageId,
          sampling_date: this.data.sampling_date
        }

        this.$store.dispatch('drainage/saveDrainage', data).then(res => {

          for(alert in res.result.PhAlerts) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(res.result.PhAlerts[alert].Message),
              type : 'err',
            })
          }

          for(alert in res.result.EcAlerts) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(res.result.EcAlerts[alert].Message),
              type : 'err',
            })
          }

          this.$notify({
              group: 'notices',
              title: this.$ml.get(`Drainage successfully saved!`),
              type : 'success',
            })
        }, rej => {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Error`),
              type : 'err',
            })
        })
      }
      } else {
        this.$notify({
              group: 'notices',
              title: this.$ml.get('Please select sampling date.'),
              type : 'error',
            })
      }

      
      
    },
    
    deleteDrainage() {
      this.$store.dispatch('drainage/deleteDrainage', {drainageId: this.data.drainageId}).then(res => {
      })
    }
  },
  created() {
    if(!this.data.data) {
      this.$store.commit('drainage/setDrainageLoading', true)
      this.$store.dispatch('drainage/selectSingleDrainage', this.id).finally(() => {this.$store.commit('drainage/setDrainageLoading', false)});
    }
  },
  watch: {
    '$route.params.id': {
      handler: function(id) {
        this.id = id;
        this.$store.dispatch('drainage/clean');
        this.$store.commit('drainage/setDrainageLoading', true)
        this.sync();
      },
      deep: true,
      immediate: true
    },
    'data.stageId': {
      handler: function(id) {
        if(id > 0) {
          this.$store.commit('drainage/setSVGLoading', true)
          this.$store.dispatch('drainage/getProgramsByCrop').finally(() => {
            this.$store.commit('drainage/setSVGLoading', false)
          })
        }
      }
    }
  },
  components: {
    General,
    CropInfo,
    Elements,
    Container,
    LoadingSVG,
  }
}
</script>

<style lang="scss" scoped>
.single {
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;

  .drainage-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    margin-bottom: 10px;
    .buttons {
      display: flex;
      justify-content: end;
      align-items: center;
      button:last-child {
        margin-left: 20px;
      }
    }
  }
  
  .headed-container {
    margin-bottom: 16px;
    width: 100%;
    &::v-deep {
      .inbody {
        padding: 16px;
        > div {
          width: 100%;
          display: block;
        }
      }
    }
    &:last-child {
      margin: 0;
    }
  }
}

.name-text {
  font-size: 29px;
}

.drainage-loader {
  width: 30px;
}
.drainage-load__content {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
